import { Fornecedores } from "app/models/fornecedor/fornecedor";
import { WindowMU } from "app/types/WindowMU";
import { FornecedoresView } from "app/views/fornecedor/fornecedorView";
import { ControllerBase } from "controllerBase";
import { Paginator } from "paginator";

declare var window:WindowMU

const PesquisarFornecedoresController = ControllerBase.extend({
    name: "PesquisarFornecedoresController",

    form: "#form-pesquisar-fornecedor",

    ajax: function() {
        return {
            url: "/Fornecedor/_Pesquisar",
            type: "get",
            cache: false
        };
    },

    renderizado: function() {

        $("#mostrar-historico-filtro").hide();
        $("#pesquisar-produtos-region").hide();
        $("#menu-consulta-produtos").hide();
        $("#menu-sub-consulta-produtos").hide();

        this.atacharEventos();
        this.configurarForm();
        global.applyMasks();

        global.applyConditionalMask({
            triggerElement: 'input[name="CnpjCpf"]',
            triggerEvent: "keydown",
            initialMask: "cpf",
            options: {
                removeMaskOnSubmit: true
            },
            masks: [
                {
                    name: "cpf",
                    mask: "999.999.999-99[9][9][9]",
                    initialCondition: function (e) {
                        var value = $(e.target).inputmask("unmaskedvalue");
                        if (value) {
                            value = global.replaceAll(value, ".", "");
                            value = global.replaceAll(value, "-", "");
                        }
                        return value && value.length <= 11;
                    },
                    condition: function (e) {
                        if (e
                            .which &&
                            (e.which == 9 || e.which == 13 || e.which == 17) ||
                            (e.ctrlKey && e.which == 86)) {
                            return false;
                        }

                        var value = $(e.target).inputmask("unmaskedvalue");
                        if (value) {
                            value = global.replaceAll(value, ".", "");
                            value = global.replaceAll(value, "-", "");
                        }
                        return value && value.length <= 11;
                    }
                },
                {
                    name: "cnpj",
                    mask: "99.999.999/9999-99",
                    initialCondition: function (e) {

                        var value = $(e.target).inputmask("unmaskedvalue");

                        if (value) {
                            value = global.replaceAll(value, ".", "");
                            value = global.replaceAll(value, "-", "");
                            value = global.replaceAll(value, "/", "");
                        }
                        return value && value.length > 11;
                    },
                    condition: function (e) {

                        if (e
                            .which &&
                            (e.which == 9 || e.which == 13 || e.which == 17) ||
                            (e.ctrlKey && e.which == 86)) {
                            return false;
                        }

                        var value = $(e.target).inputmask("unmaskedvalue");

                        if (value) {
                            value = global.replaceAll(value, ".", "");
                            value = global.replaceAll(value, "-", "");
                            value = global.replaceAll(value, "/", "");
                        }
                        return value && value.length > 11;
                    }
                }
            ]
        });

        $("#Nome").focus();
    },

    atacharEventos: function() {
        $("#pesquisar-fornecedores", $(this.container)).click($.proxy(this.pesquisar, this));
        $("input").on('focus', function () { $(this).select(); });
    },

    configurarForm: function() {

        var self = this;

        this.validationOptions = {
            errorClass: "obrigatorio",
            onkeyup: false,
            errorPlacement: function(error, element) {
                return true;
            },
            focusInvalid: false,
            invalidHandler: function(event, validator) {

                var errors = validator.numberOfInvalids();

                if (errors) {
                    var messages = new Array();

                    $.each(validator.errorList,
                        function() {
                            messages.push(this.message);
                        });

                    global.showErrorMessage(messages);

                    return false;
                }

            }
        };

        $(this.form).validate(this.validationOptions);

    },

    pesquisar: function(e) {

        if (e) {
            e.preventDefault();
        }

        global.blockUI();

        var formdata = global.convertFormToJSON({ selector: this.form });
        formdata.TamanhoPagina = this.pesquisa ? this.pesquisa.PageSize : 20;
        formdata.NumeroPagina = this.pesquisa ? this.pesquisa.ActualPage : 1;

        //var testeApp = global.toJSONString(formdata);

        var self = this;

        global.ajax({
            url: "/Fornecedor/Pesquisar",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString(formdata),
            error: function() {
                global.unblockUI();
                global.showDefaultErrorMessage();
            },
            success: function (data) {

                if (!data || data.HasErrors) {
                    return;
                }

                data = global.tratarRetorno(data);
                self.carregar(data);
            }
        });

    },

    paginar: function(e) {
        this.pesquisa.ActualPage = e.page;
        this.pesquisar();
    },

    carregar: function(data) {

        if (!data) {
            global.unblockUI();
            return;
        }

        this.pesquisa = data;

        $("#fornecedores-region").removeClass("none").addClass("separador");

        this.showView({
            region: {
                name: "fornecedoresRegion",
                selector: "#fornecedores-region"
            },
            view: {
                type: FornecedoresView,
                args: {
                    fornecedorSelecionadoCallback: this.fornecedorSelecionadoCallback,
                    collection: new Fornecedores(data.Entities)
                }
            }
        });

        this.paginador = new Paginator({
            container: "#pesquisar-fornecedores-page-container",
            data: data,
            pageClickCallback: $.proxy(this.paginar, this)
        });

        global.unblockUI();

    }
})

window.PesquisarFornecedoresController = PesquisarFornecedoresController

export {
    PesquisarFornecedoresController
}
